import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

import plausible from './plausible';


function Analytics({children}) {

    if (plausible) {

        const cleanUp = plausible.enableAutoPageviews();

        useEffect(() => () => cleanUp());
    }

    return children;
}


Analytics.propTypes = {
    children: PropTypes.any
};


export default Analytics;
